'use client';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useSiteMapContext } from './site_map_context';

type SiteMapSearchProps = {
    placeholder?: string;
};

function SiteMapSearch({
    placeholder = 'Search by unit name...',
}: SiteMapSearchProps) {
    const { searchQuery, setSearchQuery } = useSiteMapContext();

    return (
        <div className="paragraph-site-map-search flex min-w-0 w-full max-w-full sm:max-w-sm flex-row items-center rounded-md border border-divider px-2.5 sm:py-3 py-2">
            <MagnifyingGlassIcon
                className="size-4 sm:size-5 shrink-0 text-gray-500"
                aria-hidden
            />
            <input
                type="text"
                placeholder={placeholder}
                className="min-w-0 w-full flex-1 border-none bg-transparent py-0 leading-tight placeholder:sm:text-base placeholder:leading-tight placeholder:text-sm placeholder:font-normal focus:ring-0"
                aria-label="Site Map Search"
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
            />
        </div>
    );
}

export default SiteMapSearch;